<template>
  <date-picker :type="type"
                  :picker-options="pickOptions"
                  v-model="currentValue"
                  :editable="false"
                  :readonly="readonly"
                  :disabled="disabled"
                  style="width:100%;" @change="handleChange">
  </date-picker>
</template>

<script>
  export default {
    name: "fpDatebox",
    props: [
      "range", "options", "value", 'onlyFulture', 'readonly', 'disabled'
    ],
    created() {
      if (!this.value) {
        if (this.range) {
          this.currentValue = [moment().startOf('day'), moment().endOf('day')];
        } else {
          this.currentValue = moment().startOf('day');
        }
      } else {
        this.currentValue = this.value;
      }
      if (this.range) {
        this.$emit('input', this.currentValue);
      } else {
        this.$emit('input', moment(this.currentValue));
      }
    },
    data() {
      return {
        currentValue: ""
      }
    },
    watch: {
      value: function (nv, ov) {
        this.currentValue = nv;
      }
    },
    computed: {
      type() {
        return this.range == "true" ? "daterange" : "date";
      },
      pickOptions() {
        if (this.range == "true") {
          return $.extend({
            shortcuts: [{
              text: this.l('近1周'),
              onClick(picker) {
                picker.$emit('pick', [moment().startOf('week'), moment().endOf('day')]);
              }
            }, {
              text: this.l('近1月'),
              onClick(picker) {
                picker.$emit('pick', [moment().startOf('months'), moment().endOf('day')]);
              }
            }, {
              text: this.l('近3月'),
              onClick(picker) {
                picker.$emit('pick', [moment().startOf('months').add(-2, 'months'), moment().endOf('day')]);
              }
            }]
          }, this.options);
        } else if (this.onlyFulture == "true") {
          return $.extend({
            disabledDate: function (time) {
              return time.getTime() < Date.now();
            }
          }, this.options);
        } else {
          return $.extend({}, this.options);
        }

      }
    },
    methods: {
      handleChange(v){
        if (this.range == "true") {
          if (!this.currentValue[0] && !this.currentValue[1]) {
            this.$emit('input', []);
          } else {
            this.$emit('input', [moment(this.currentValue[0]), moment(this.currentValue[1])]);
          }
        } else {
          this.$emit('input', moment(this.currentValue));
        }

      }
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// dateTimeBox.vue?761efedf